/* CS PDP v2
   1. On small screens move the title, rating and price blocks above the gallery, and move
      them back on wider screens. The nodes are moved, not copied, so the h1 stays unique,
      the Okendo star widget keeps its handlers and the live price keeps updating.
   2. Move the "Enlarge current image" control onto the image itself. */
(() => {
	'use strict'
	const root = document.getElementById('cs-pdp')
	if (!root) return

	// ---- 1. Title first on mobile ----
	const head = root.querySelector('[data-cs-mhead]')
	const info = root.querySelector('.l-pdp__info-inner')
	if (head && info && root.hasAttribute('data-cs-title-first')) {
		const mq = window.matchMedia('(max-width: 767px)')
		const pick = () => {
			const kids = [...info.children]
			return [
				kids.find((el) => /(^|\s)l-bHeading(\s|$)/.test(el.className) && /__title(\s|$)/.test(el.className)),
				kids.find((el) => /__rating(\s|$)/.test(el.className)),
				kids.find((el) => el.nodeType === 1 && (el.matches('l-product-price') || el.querySelector(':scope > l-product-price') || /__price(\s|$)/.test(el.className))),
			].filter(Boolean)
		}
		const markers = new Map()
		const toHead = () => {
			pick().forEach((el) => {
				if (!markers.has(el)) {
					const m = document.createComment('cs-mhead-slot')
					el.before(m)
					markers.set(el, m)
				}
				head.append(el)
			})
		}
		const toInfo = () => {
			;[...head.children].forEach((el) => {
				const m = markers.get(el)
				if (m && m.parentNode) m.replaceWith(el)
				else info.prepend(el)
				markers.delete(el)
			})
		}
		const apply = () => (mq.matches ? toHead() : toInfo())
		apply()
		mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply)
		// The theme re-renders parts of the info column on variant change. If a fresh title,
		// rating or price node appears there while we are on mobile, move it up as well.
		new MutationObserver(() => {
			if (mq.matches) toHead()
		}).observe(info, { childList: true })
	}

	// ---- 2. Enlarge control on the image ----
	const zoom = root.querySelector('.l-pMedia > [data-baja-zoom]')
	if (zoom) {
		const carousels = [...root.querySelectorAll('[data-main-carousel]')]
		if (carousels.length) {
			carousels.forEach((carousel, i) => {
				const button = i === 0 ? zoom : zoom.cloneNode(true)
				button.textContent = ''
				button.title = 'Enlarge image'
				button.setAttribute('aria-label', 'Enlarge current image')
				carousel.append(button)
			})
		}
	}
})()

/* CS PDP v2 (2): intro read-more + TIDAL compare navigation on mobile */
;(() => {
	'use strict'
	const root = document.getElementById('cs-pdp')
	if (!root) return

	// ---- Intro: clamp to two lines with a Read more toggle ----
	const setupIntro = () => {
		root.querySelectorAll('.l-bPIntro').forEach((intro) => {
			let btn = intro.nextElementSibling && intro.nextElementSibling.matches('.cs-readmore') ? intro.nextElementSibling : null
			intro.classList.remove('cs-clamp', 'is-open')
			const lh = parseFloat(getComputedStyle(intro.querySelector('p') || intro).lineHeight) || 20
			const needs = intro.scrollHeight > lh * 2.6
			if (!needs) { if (btn) btn.hidden = true; return }
			intro.style.setProperty('--cs-lh', lh + 'px')
			intro.classList.add('cs-clamp')
			if (!btn) {
				btn = document.createElement('button')
				btn.type = 'button'
				btn.className = 'cs-readmore'
				intro.after(btn)
				btn.addEventListener('click', () => {
					const open = intro.classList.toggle('is-open')
					btn.textContent = open ? 'Show less' : 'Read more'
					btn.setAttribute('aria-expanded', String(open))
				})
			}
			btn.hidden = false
			btn.textContent = 'Read more'
			btn.setAttribute('aria-expanded', 'false')
		})
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupIntro)
	else setupIntro()
	document.addEventListener('l:variant:changed', () => setTimeout(setupIntro, 80))
	window.addEventListener('resize', () => { clearTimeout(setupIntro._t); setupIntro._t = setTimeout(setupIntro, 150) })

	// ---- TIDAL compare table (mobile): count, previous/next and swipe ----
	const setupCompare = (table) => {
		if (table.dataset.csNav) return
		const triggers = [...table.querySelectorAll('[data-trigger]')]
		if (triggers.length < 2 || typeof table.activate !== 'function') return
		table.dataset.csNav = '1'
		const nav = document.createElement('div')
		nav.className = 'cs-cmpnav'
		nav.innerHTML = '<button type="button" class="cs-cmpnav__btn" data-dir="-1" aria-label="Previous brand"></button><span class="cs-cmpnav__label" aria-live="polite"></span><button type="button" class="cs-cmpnav__btn" data-dir="1" aria-label="Next brand"></button>'
		const hint = document.createElement('p')
		hint.className = 'cs-cmphint'
		hint.textContent = 'Compare TIDAL with ' + triggers.length + ' brands. Tap a name or swipe the chart.'
		const swiper = table.querySelector('l-swiper-carousel')
		if (swiper) swiper.before(hint)
		table.append(nav)
		const label = nav.querySelector('.cs-cmpnav__label')
		const current = () => Math.max(0, triggers.findIndex((t) => t.classList.contains('is-active')))
		const render = () => {
			const i = current()
			label.textContent = triggers[i].textContent.trim() + '  ·  ' + (i + 1) + ' of ' + triggers.length
			nav.querySelector('[data-dir="-1"]').disabled = i === 0
			nav.querySelector('[data-dir="1"]').disabled = i === triggers.length - 1
		}
		const go = (dir) => {
			const i = Math.min(triggers.length - 1, Math.max(0, current() + dir))
			table.activate(triggers[i].dataset.trigger)
			render()
		}
		nav.addEventListener('click', (e) => { const b = e.target.closest('[data-dir]'); if (b && !b.disabled) go(Number(b.dataset.dir)) })
		triggers.forEach((t) => t.addEventListener('click', () => setTimeout(render, 0)))
		let x0 = null, y0 = null
		table.querySelectorAll('[data-content]').forEach((panel) => {
			panel.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY }, { passive: true })
			panel.addEventListener('touchend', (e) => {
				if (x0 === null) return
				const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0
				if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1)
				x0 = null
			}, { passive: true })
		})
		render()
	}
	const initCompare = () => document.querySelectorAll('l-tidal-compare-table-mobile').forEach(setupCompare)
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(initCompare, 50))
	else setTimeout(initCompare, 50)
	window.addEventListener('load', initCompare)
})()

/* CS PDP v2 (3): place the How to store tab inside the product's Overview / How To Use list */
;(() => {
	'use strict'
	const place = () => {
		document.querySelectorAll('template[data-cs-store-tab]').forEach((tpl) => {
			if (tpl.dataset.placed) return
			tpl.dataset.placed = '1'
			const info = tpl.closest('.l-pdp__info-inner') || document
			const lastTab = [...info.querySelectorAll('.l-bFaqs l-collapsible-tab')].filter((t) => !t.classList.contains('cs-storeTab'))[0]
			const list = lastTab ? lastTab.parentElement : null
			const node = tpl.content.cloneNode(true)
			if (list) {
				const firstFaqs = list
				const tabs = [...firstFaqs.querySelectorAll(':scope > l-collapsible-tab')]
				const howTo = tabs.find((t) => /how to use/i.test(t.querySelector('[data-trigger]')?.textContent || ''))
				;(howTo || tabs[tabs.length - 1]).after(node)
			} else {
				tpl.after(node)
			}
		})
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place)
	else place()
})()

/* CS PDP v2 (4): gallery review carousel, live product reviews from Okendo (static reviews as fallback) */
;(() => {
	'use strict'
	const esc = (t) => String(t || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
	const build = (root) => {
		const track = root.querySelector('.cs-greviews__track'), dotsWrap = root.querySelector('.cs-greviews__dots')
		let slides = [...root.querySelectorAll('.cs-greview')], dots = [...root.querySelectorAll('.cs-greviews__dot')], i = 0, timer
		const go = (n) => { i = (n + slides.length) % slides.length; track.style.transform = `translateX(-${i * 100}%)`; dots.forEach((d, k) => d.classList.toggle('is-active', k === i)) }
		const auto = () => { clearInterval(timer); if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => go(i + 1), 6000) }
		root.addEventListener('click', (e) => { const b = e.target.closest('[data-dir]'); if (b) { go(i + Number(b.dataset.dir)); auto() } })
		root.addEventListener('mouseenter', () => clearInterval(timer)); root.addEventListener('mouseleave', auto)
		root._csSet = (list) => {
			track.innerHTML = list.map((r, k) => `<figure class="cs-greview" aria-roledescription="slide" aria-label="${k + 1} of ${list.length}"><div class="cs-greview__stars" aria-label="${r.rating} out of 5 stars">${'★'.repeat(r.rating)}</div>${r.title ? `<p class="cs-greview__heading">${esc(r.title)}</p>` : ''}<blockquote class="cs-greview__text">“${esc(r.body)}”</blockquote><figcaption class="cs-greview__meta"><span class="cs-greview__name">${esc(r.name)}${r.verified ? ' <span class="cs-greview__verified">Verified buyer</span>' : ''}</span></figcaption></figure>`).join('')
			dotsWrap.innerHTML = list.map((_, k) => `<span class="cs-greviews__dot${k === 0 ? ' is-active' : ''}"></span>`).join('')
			slides = [...root.querySelectorAll('.cs-greview')]; dots = [...root.querySelectorAll('.cs-greviews__dot')]; go(0); auto()
			root.querySelector('.cs-greviews__nav').hidden = list.length < 2; dotsWrap.hidden = list.length < 2
		}
		auto()
	}
	document.querySelectorAll('[data-cs-greviews]').forEach((root) => {
		build(root)
		const store = root.dataset.okeStore, pid = root.dataset.productId
		if (!store || !pid || !window.fetch) return
		fetch(`https://api.okendo.io/v1/stores/${store}/products/shopify-${pid}/reviews?limit=25&orderBy=date%20desc`)
			.then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
			.then((d) => {
				const list = (d.reviews || [])
					.filter((r) => r.rating >= 5 && r.body && r.body.trim().length >= 40 && r.body.length <= 260)
					.filter(((seen) => (r) => { const k = ((r.reviewer && r.reviewer.displayName) || '') + '|' + r.body.slice(0, 30); const n = (r.reviewer && r.reviewer.displayName) || ''; if (seen.has(n) && n) return false; seen.add(n); return !seen.has(k) || true })(new Set()))
					.slice(0, 6)
					.map((r) => ({ rating: r.rating, title: /^(\d(\.\d)?\s*)?(stars?|out of 5)$/i.test((r.title || '').trim()) ? '' : (r.title || '').trim(), body: r.body.replace(/\s+/g, ' ').trim(), name: (r.reviewer && r.reviewer.displayName) || 'Verified buyer', verified: !!(r.reviewer && r.reviewer.isVerified) }))
				if (list.length) root._csSet(list)
			})
			.catch(() => {})
	})
})()

/* CS PDP v2 (5): price inside the Add to cart button (shown on mobile via CSS) */
;(() => {
	'use strict'
	const root = document.getElementById('cs-pdp'); if (!root) return
	const sync = () => {
		const btn = root.querySelector('.l-bPControl__submit'); if (!btn || btn.disabled) { btn && btn.querySelector('.cs-atc-price')?.remove(); return }
		const priceEl = root.querySelector('.l-pPrice__normal'); const price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : ''
		if (!price) return
		let span = btn.querySelector('.cs-atc-price')
		if (!span) { span = document.createElement('span'); span.className = 'cs-atc-price'; (btn.querySelector('.l-bPControl__submit-label') || btn).append(span) }
		const txt = '  –  ' + price
		if (span.textContent !== txt) span.textContent = txt
	}
	let q = false
	const schedule = () => { if (q) return; q = true; requestAnimationFrame(() => { q = false; sync() }) }
	sync(); window.addEventListener('load', sync)
	new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true })
	document.addEventListener('change', () => setTimeout(sync, 80))
})()

/* CS PDP v2 (6): swap formula-specific facts ([core] / [!core]) on variant change */
;(() => {
	'use strict'
	const root = document.getElementById('cs-pdp'); if (!root) return
	const title = () => [...root.querySelectorAll('input[data-product-variant-input]:checked')].map((i) => i.value).join(' / ').toLowerCase()
	const sync = () => {
		const t = title(); if (!t) return
		root.querySelectorAll('[data-cs-fact-tag]').forEach((li) => {
			const tag = li.dataset.csFactTag, neg = tag[0] === '!', want = tag.replace(/^!/, '')
			const show = neg ? !t.includes(want) : t.includes(want)
			if (li.hidden === show) li.hidden = !show
		})
		root.querySelectorAll('.baja-compare [data-col]').forEach((c) => c.classList.toggle('is-active', (c.dataset.col === 'core') === t.includes('core')))
	}
	document.addEventListener('change', () => setTimeout(sync, 30))
	document.addEventListener('l:variant:changed', () => setTimeout(sync, 30))
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync()
})()

/* CS PDP v2 (7): price per serving sits under the price; on phones (top price hidden) it sits above the buy buttons */
;(() => {
	'use strict'
	const root = document.getElementById('cs-pdp'); if (!root) return
	const info = root.querySelector('.l-pdp__info-inner'); if (!info) return
	const pps = [...info.children].find((el) => el.querySelector && el.querySelector('[data-cs-pps], .l-bPps, .cs-pps') || /pps|per-serving|perServing/i.test(el.className))
	if (!pps) return
	const slot = document.createComment('cs-pps-slot'); pps.before(slot)
	const mq = window.matchMedia('(max-width: 767px)')
	const apply = () => {
		const controls = [...info.children].find((el) => el.matches && (el.matches('.l-bPControl, .l-bPControl-wrapper') || el.querySelector('.l-bPControl')))
		if (mq.matches && controls) { if (pps.nextElementSibling !== controls) controls.before(pps) }
		else if (slot.parentNode && slot.nextSibling !== pps) slot.after(pps)
	}
	apply(); mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply)
})()

/* CS PDP v2 (9): Fine vs Natural Grain popup (replaces sending shoppers into the full quiz) */
;(() => {
	'use strict'
	let dlg = null, lastFocus = null
	const build = () => {
		if (dlg && document.body.contains(dlg)) return dlg
		const tpl = document.querySelector('template[data-cs-grain-tpl]'); if (!tpl) return null
		dlg = tpl.content.firstElementChild.cloneNode(true); document.body.append(dlg)
		dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-cs-grain-close]')) close() })
		dlg.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close() } }, true)
		dlg.addEventListener('close', () => { document.documentElement.classList.remove('cs-grain-open'); if (lastFocus) lastFocus.focus() })
		return dlg
	}
	const open = (btn) => { const d = build(); if (!d) return; lastFocus = btn; document.documentElement.classList.add('cs-grain-open'); d.showModal(); d.querySelector('.cs-grain-dlg__close').focus() }
	const close = () => { if (dlg && dlg.open) dlg.close() }
	document.addEventListener('click', (e) => { const b = e.target.closest('[data-cs-grain-open]'); if (b) { e.preventDefault(); open(b) } })
})()

/* CS PDP v2 (10): TIDAL "What's the difference?" opens a Hydrate vs Core popup; Choose buttons switch the formula */
;(() => {
	'use strict'
	let dlg = null, lastFocus = null
	const close = () => { if (dlg && dlg.open) dlg.close() }
	const build = () => {
		const tpl = document.querySelector('template[data-cs-cmp-tpl]'); if (!tpl) return null
		if (dlg) dlg.remove()
		dlg = tpl.content.firstElementChild.cloneNode(true); document.body.append(dlg)
		dlg.addEventListener('click', (e) => {
			if (e.target === dlg || e.target.closest('[data-cs-dlg-close]')) return close()
			const pick = e.target.closest('[data-cs-pick-formula]')
			if (pick) {
				const btn = [...document.querySelectorAll('[data-baja-formula="' + pick.dataset.csPickFormula + '"]')].find((b) => b.getClientRects().length)
				close(); if (btn) btn.click()
			}
		})
		dlg.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close() } }, true)
		dlg.addEventListener('close', () => { document.documentElement.classList.remove('cs-grain-open'); if (lastFocus && document.contains(lastFocus)) lastFocus.focus() })
		return dlg
	}
	document.addEventListener('click', (e) => {
		const b = e.target.closest('[data-cs-cmp-open]'); if (!b) return
		e.preventDefault(); const d = build(); if (!d) return
		lastFocus = b; document.documentElement.classList.add('cs-grain-open'); d.showModal(); d.querySelector('.cs-grain-dlg__close').focus()
	})
})()

/* CS PDP v2 (11): fruit badges on TIDAL flavor tiles (the tub photos look alike) */
;(() => {
	'use strict'
	const root = document.getElementById('cs-pdp'); if (!root) return
	const I = {
		strawberry: '<path d="M12 7.5c3.6 0 6.5 1.8 6.5 4.6 0 4-3.6 8.4-6.5 8.4s-6.5-4.4-6.5-8.4c0-2.8 2.9-4.6 6.5-4.6z"/><path d="M9 4.5c1.2 1.4 2 2 3 3 1-1 1.8-1.6 3-3M12 7.5V3.5"/><path d="M9.5 11.5h.01M14.5 11.5h.01M12 14h.01M9.8 16.2h.01M14.2 16.2h.01" stroke-width="2.4"/>',
		watermelon: '<path d="M3.5 9.5a8.5 8.5 0 0 0 17 0z"/><path d="M6.4 9.5a5.6 5.6 0 0 0 11.2 0"/><path d="M9.5 12.2h.01M12 13.6h.01M14.5 12.2h.01" stroke-width="2.4"/>',
		berries: '<circle cx="8.5" cy="14.5" r="3.5"/><circle cx="15.5" cy="14.5" r="3.5"/><circle cx="12" cy="9" r="3.5"/><path d="M12 5.5c0-1.6 1-2.6 2.6-2.8"/>',
		citrus: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="5.5"/><path d="M12 6.5v11M6.5 12h11M8.1 8.1l7.8 7.8M15.9 8.1l-7.8 7.8"/>',
		kiwi: '<ellipse cx="12" cy="12" rx="8.5" ry="8"/><ellipse cx="12" cy="12" rx="2.6" ry="2.2"/><path d="M12 6.4h.01M12 17.6h.01M6.6 12h.01M17.4 12h.01M8.2 8.2h.01M15.8 8.2h.01M8.2 15.8h.01M15.8 15.8h.01" stroke-width="2.4"/>',
		cherry: '<circle cx="7.5" cy="16.5" r="3.5"/><circle cx="16.5" cy="16.5" r="3.5"/><path d="M7.5 13c1.5-4 3.5-7 7-9.5M16.5 13c-.5-3.5-1-6-2-9.5M14.5 3.5c2 .2 3.6 1 4.5 2.5"/>',
		mango: '<path d="M7 18.5c-3-3-3-8.5.5-11.6 3.3-3 8.6-3.4 11 0 2.6 3.7.3 9.8-4 12-2.8 1.4-5.6 1.4-7.5-.4z"/><path d="M15 6c.5-1.5 1.8-2.5 3.5-2.5"/>'
	}
	const MAP = {
		'Strawberry Lemonade': ['strawberry', '#e8425a', '#f6d44a'], 'Watermelon Lime': ['watermelon', '#ef5b6e', '#7cc242'], 'Mixed Berry': ['berries', '#6c3fa0', '#d0417e'],
		'Lemon Lime': ['citrus', '#e5c22c', '#8cc63f'], 'Orange Vanilla': ['citrus', '#f5902e', '#f6c77e'], 'Tropical Kiwi': ['kiwi', '#7dbb3c', '#f4c542'],
		'Citrus Spark': ['citrus', '#f2b51f', '#f08a24'], 'Cherry Frost': ['cherry', '#b3203c', '#7fd3ec'], 'Mango Surge': ['mango', '#f7a531', '#f26b3a']
	}
	const apply = () => root.querySelectorAll('.l-pVp__swatch-image[aria-label]').forEach((lab) => {
		if (lab.querySelector('.cs-fruit')) return
		const m = MAP[lab.getAttribute('aria-label')]; if (!m) return
		const s = document.createElement('span'); s.className = 'cs-fruit'; s.setAttribute('aria-hidden', 'true')
		s.style.background = 'linear-gradient(135deg,' + m[1] + ',' + m[2] + ')'
		s.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + I[m[0]] + '</svg>'
		lab.append(s)
	})
	apply(); new MutationObserver(apply).observe(root, { childList: true, subtree: true })
})()
